import "whatwg-fetch";
import {
  getAPIConfig,
  convertQueryObjToString,
  handleAPIResponse,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";
import type { BannersAdapter } from "../types";

const commercialBannersAdapter: BannersAdapter = {
  fetchAllBanners: async (fetchConfig?: Record<string, any>) => {
    let route = `/commercial/${localStorage.ctid}/banners${
      fetchConfig ? `${convertQueryObjToString(fetchConfig, true)}` : ""
    }`;
    const apiConfig = getAPIConfig(route, false);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchIndividualBanner: async (bannerId: string | number) => {
    const route = `/commercial/${localStorage.ctid}/banners/id/${bannerId}`;
    const apiConfig = getAPIConfig(route, false);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  fetchPositions: async () => {
    let route = `/commercial/${localStorage.ctid}/banners/config`;
    const apiConfig = getAPIConfig(route, false);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },

  postNewBanner: async (changes: Record<string, any>) => {
    const route = `/commercial/${localStorage.ctid}/banners`;
    const apiConfig = getAPIConfig(route, false);
    const response = await executeAPIRequest(apiConfig, "POST", {}, changes);
    try {
      const responseData = await response.json();
      return handleAPIResponse(responseData);
    } catch (err) {
      console.warn(err);
      return handleAPIResponse(response);
    }
  },

  patchBanner: async (bannerId: string | number, changes: Record<string, any>) => {
    const route = `/commercial/${localStorage.ctid}/banners/id/${bannerId}`;
    const apiConfig = getAPIConfig(route, false);
    const response = await executeAPIRequest(apiConfig, "PATCH", {}, changes);
    try {
      const responseData = await response.json();
      return handleAPIResponse(responseData);
    } catch (err) {
      console.warn(err);
      return handleAPIResponse(response);
    }
  },

  importAllBanners: async (ctid: string) => {
    const route = `/commercial/${localStorage.ctid}/banners/live?import_ctid=${ctid}`;
    const apiConfig = getAPIConfig(route, false);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
};

window.commercialBannersAdapter = commercialBannersAdapter;

export default commercialBannersAdapter;
export type { BannersAdapter };
